module.exports = __webpack_public_path__ + "static/media/about.bb49c289.png";